// When a user uploads a profile photo via POST /2/user,
// the image is enqueued for processing / uploading to S3.

// Until that background task completes, GET-ing that image
// from S3 will result in a 403.

// This helper lets us wait (up to a timeout) for this processing
// to complete before updating the image URL in the nav bar.

function waitForImageToExist({
  src, retryDelay, timeout, resolveWith,
}) {
  return new Promise((resolve) => {
    let interval;
    const done = () => {
      clearInterval(interval);
      resolve(resolveWith);
    };

    setTimeout(done, timeout);

    interval = setInterval(() => {
      const img = new Image();
      img.src = src;
      img.onload = done;
      // img.onerror --> do nothing, just keep re-trying
    }, retryDelay);
  });
}

export default waitForImageToExist;
